import React from 'react';
import { ModalHeader, ModalBody } from 'reactstrap';
import StaticHtmlContent from "../../../common/staticHtmlContent";
import { INITIATE_REQUEST_ACEEPT_GRANT_FALLBACK_TERMS } from "../../../../constants/textConstants";

// Making this component as the class component as Print component needs the ref
class GrantPharmacyAdultProxyTerms extends React.Component {
    constructor(props) {
        super(props);
        this.childRef = React.createRef();
    }
    render() {
        const { toggleModal, heading, termsandconditions } = this.props;
        const terms = termsandconditions ? termsandconditions : INITIATE_REQUEST_ACEEPT_GRANT_FALLBACK_TERMS;
        return (
                <div ref={this.childRef}>
                    <ModalHeader toggle={toggleModal} className='head to-print'>{heading}</ModalHeader>
                    <ModalBody>
                        <StaticHtmlContent content={terms} />
                    </ModalBody>
                </div>);
    }
}
export default GrantPharmacyAdultProxyTerms;
